module.exports = __webpack_public_path__ + "382b6c7a6a36e6e41b77ce1624e56deb.svg";